import { render, staticRenderFns } from "./edit-external.vue?vue&type=template&id=2daedd86&scoped=true&"
import script from "./edit-external.vue?vue&type=script&lang=ts&"
export * from "./edit-external.vue?vue&type=script&lang=ts&"
import style0 from "./edit-external.vue?vue&type=style&index=0&id=2daedd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daedd86",
  null
  
)

export default component.exports